module.exports = __webpack_public_path__ + "img/timer_resume.bf45c451.svg";